//import { post, put } from "axios";
import axios from 'axios';
import { getApiAsyn, baseUrl, postApiAsynArrayBuffer, deleteApi, getAuthHeaders } from "../../../PostAPI";
import { handleAPIError, APIError } from "../../../common/errorHandler";
import { API_URL } from "../../../../utils/constant";
import { extractData, formatDatesHyphan } from "../../../../utils";
import { decorateWithPaginationParamsPost, decorateWithSortParamsPost, getDecoratedUrl } from "../../../common/urlService";
import { getPayloadInfo } from '../ReservationsServices';



const { post, put, get } = axios;

const getCommonRequestBody = (payload) => {
  const { isSearch } = payload;
  let sortdata = decorateWithSortParamsPost(payload);
  if (sortdata === "") {
    sortdata = "id,desc";
  }
  let startDate = formatDatesHyphan(getPayloadInfo(payload?.additinalFilter, "startDate"));
  let locationId = getPayloadInfo(payload?.additinalFilter, "location");
  let networkId = getPayloadInfo(payload?.additinalFilter, "network");
  let endDate = formatDatesHyphan(getPayloadInfo(payload?.additinalFilter, "endDate"));
  let pageno = isSearch ? {} : decorateWithPaginationParamsPost(payload);

  // Helper to check if value is empty (null, undefined, empty string, or empty array)
  const isEmpty = (val) => val === null || val === undefined || val === "" || (Array.isArray(val) && val.length === 0);

  // Extract column text filters from payload
  const columnFilters = payload?.filters || [];
  const getFilterValue = (filterKey) => {
    const filter = columnFilters.find(f => f.filterField === filterKey);
    return filter?.query || null;
  };

  return {
    paged: true,
    pageNumber: isSearch ? payload.pageNumber : pageno?.pageNumber,
    pageSize: isSearch ? payload.pageSize : pageno?.pageSize,
    userId: localStorage.getItem("userId"),
    sort: sortdata,
    startDate: startDate,
    endDate: endDate,
    locationId: isEmpty(locationId) ? [0] : locationId,
    networkId: isEmpty(networkId) ? [0] : networkId,
    type: getPayloadInfo(payload?.additinalFilter, "type") || null,
    // Text-based column filters
    filterRef: getFilterValue("ref"),
    filterNetworkBookingNo: getFilterValue("networkBookingNo"),
    filterNetworkTitle: getFilterValue("networkTitle"),
    filterLocationTitle: getFilterValue("locationTitle"),
    filterVehicle: getFilterValue("vehicle"),
    filterBookingDate: getFilterValue("bookingDate"),
    filterPickup: getFilterValue("pickup"),
    filterDropoff: getFilterValue("dropoff"),
    filterDays: getFilterValue("days"),
    filterTotalAmount: getFilterValue("totalAmount"),
    filterCurrencyCode: getFilterValue("currencyCode"),
    filterName: getFilterValue("name"),
    filterPaymentStatus: getFilterValue("paymentStatus"),
    filterRateType: getFilterValue("rateType"),
    filterStatus: getFilterValue("status"),
  };
};

export const fetchReservationsPrepaidBookingsReport1 = async (payload) => {
  const url = getDecoratedUrl({
    url: API_URL.RESERVATIONS_PREPAIDBOOKINGSREPORT.GET,
    payload,
  });
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    return result; //extractData(result, !payload?.filters);
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};


export const fetchReservationsPrepaidBookingsReport = async (payload) => {
  const requestBody = getCommonRequestBody(payload);
  try {
    let result = await dataUploadApi(
      `${API_URL.RESERVATIONS_PREPAIDBOOKINGSREPORT.GET}`,
      requestBody
    );
    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchReservationsPrepaidBookingsReportDropdown = async (payload) => {
  const url = API_URL.RESERVATIONS_PREPAIDBOOKINGSREPORT.DROPDOWN;
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    return result; //extractData(result, !payload?.filters);
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};



export const multipartDataUploadImage = (url, payload) => {
 
  const formPayload = new FormData();
  formPayload.append("file", payload?.file[0]);
  const config = {
    headers: {
      ...getAuthHeaders(localStorage.getItem("token")),
      "Content-Type": "multipart/form-data",
    },
  };
  return post(baseUrl + url, formPayload, config);
};



export const upladImageData = async (payload) => {
  const url = API_URL.UPLOAD_IMAGE.replace(
    ":id",
    payload.id
  );
  try {
    let result = await multipartDataUploadImage(
      url,
      payload
    );

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};
const dataUploadApi = (url, data, isEdit = false) => {
  const config = {
    headers: getAuthHeaders(localStorage.getItem("token")),
  };

  if (isEdit) {
    return post(baseUrl + url, data, config);
  } else {
    return post(baseUrl + url, data, config);
  }
};
export const createReservationsPrepaidBookingsReport = async (payload) => {
  try {
    let result = await dataUploadApi(
      `${API_URL.RESERVATIONS_PREPAIDBOOKINGSREPORT.CREATE}`,
      payload
    );

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const editReservationsPrepaidBookingsReport = async (payload) => {
  const url = API_URL.RESERVATIONS_PREPAIDBOOKINGSREPORT.EDIT.replace(":id", payload?.id);

  try {
    let result = await dataUploadApi(url, payload.data, true);

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};





const dataExportApi = (url, data) => {
  const config = {
    headers: getAuthHeaders(localStorage.getItem("token")),
  };
    return get(baseUrl + url, data, config);
};

export const exportReservationsPrepaidBookingsReportRecord = async (payload) => {
  // const url = API_URL.RESERVATIONS_PREPAIDBOOKINGSREPORT.EXPORT;
  // try {
  //   let result = await getApiAsynarrayBuffer(url, localStorage.getItem("token"));
  //   if (result?.error) {
  //     throw new APIError(result);
  //   }
  //   return result;


  let sortdata = decorateWithSortParamsPost(payload);
  console.log("AKA", payload)
  if(sortdata===""){
    sortdata="id,desc"
  }
 
   let startDate = formatDatesHyphan(getPayloadInfo(payload, "startDate"));
   let locationId  = getPayloadInfo(payload, "location");
   let networkId  = getPayloadInfo(payload, "network");
   let endDate  = formatDatesHyphan(getPayloadInfo(payload, "endDate"));
   let pageno = decorateWithPaginationParamsPost(payload);
  let payloads={
    paged: false, // For Excel export, get all records without pagination
    pageNumber: pageno?.pageNumber,
    pageSize: pageno?.pageSize,
    userId:localStorage.getItem("userId"),
    sort: sortdata,
    startDate: startDate + " 00:00:00" ?? "",
    endDate: endDate + " 00:00:00"?? "",
    locationId: (locationId ?? "") === "" ? [0] : locationId,
    networkId: (networkId ?? "") === "" ? [0] : networkId,
  }
  try {
    //let result = await getApiAsyn(url, localStorage.getItem("token"));
    let result = await postApiAsynArrayBuffer(
      `${API_URL.RESERVATIONS_PREPAIDBOOKINGSREPORT.EXPORT}`,
      payloads,
      localStorage.getItem("token")
    );
    if (result?.error) {
      throw new APIError(result);
    }
    return result; //extractData(result, !payload?.filters);

  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};




export const fetchReservationsPrepaidBookingsReportById = async (payload) => {
  const url = API_URL.RESERVATIONS_PREPAIDBOOKINGSREPORT.GET_BY_ID.replace(
    ":id",
    payload?.id
  );
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    result = extractData(result, !payload?.filters);

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};
export const deleteReservationsPrepaidBookingsReport = async (payload) => {
  try {
     const url = API_URL.RESERVATIONS_PREPAIDBOOKINGSREPORT.DELETE.replace(
      ":id",
      payload?.id
    );

      let result = await deleteApi(url, localStorage.getItem("token"));
    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};  